import React from "react";
import UserManagementPage from "./UserManagementPage";
import { DREAM_ROLE_LIST } from "../../constants";
import useAuthStore from "../../store/authStore";
import { canManageDream } from "../../utils/adminAccess";

const dreamUserListEndpointBuilder = (role) => `/api/admin/dream-users?role=${role}`;
const dreamUserDetailEndpointBuilder = (userId) => `/api/admin/dream-users/${userId}`;
const dreamUserRequestHistoryEndpointBuilder = (userId) => `/api/admin/dream-users/${userId}/requests`;

function DreamUserManagementPage() {
  const user = useAuthStore((state) => state.user);
  const canMutate = canManageDream(user);

  return (
    <UserManagementPage
      title="들어드림 회원·작업자"
      roles={DREAM_ROLE_LIST}
      defaultRole="dream_user"
      enableCollectorApproval={canMutate}
      enableAccountStatusManagement={canMutate}
      readOnly={!canMutate}
      listEndpointBuilder={dreamUserListEndpointBuilder}
      detailEndpointBuilder={dreamUserDetailEndpointBuilder}
      requestHistoryEndpointBuilder={dreamUserRequestHistoryEndpointBuilder}
      deleteEndpoint="/api/admin/dream-users"
      deleteDialogTitle="들어드림 계정 삭제 확인"
      deleteDialogDescription="선택한 계정을 삭제합니다. 운영 이력이 없는 테스트성 들어드림 이용자/작업자만 삭제됩니다."
      deleteDialogWarning="수거 요청 또는 완료 기록이 있는 계정은 삭제되지 않으며, 정지/탈퇴/익명화 정책으로 처리해야 합니다."
      deleteSuccessMessage="선택한 들어드림 계정이 삭제되었습니다."
    />
  );
}

export default DreamUserManagementPage;
